import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base/base.component';
import { withDialogComponent } from '@shared/components/dialog';
import { NavigationComponent } from '@shared/components/navigation/navigation.component';
import { ProfileMenuComponent } from '@shared/components/profile-menu/profile-menu.component';
import { SidebarComponent } from '@shared/components/sidebar/sidebar.component';
import { SidebarService } from '@shared/services/local/sidebar.service';
import { CURRENT_USER } from '@shared/tokens/current-user.token';
import { NAVIGATION } from '@shared/tokens/navigation.token';
import { AssistantChatDialogComponent } from '../../../../features/assistant/dialogs/assistant-chat/assistant-chat-dialog.component';

@Component({
  selector: 'backoffice-base-layout-sidebar',
  imports: [
    SidebarComponent,
    NavigationComponent,
    ProfileMenuComponent,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './base-layout-sidebar.component.html',
  styleUrl: './base-layout-sidebar.component.css',
})
export class BaseLayoutSidebarComponent extends withDialogComponent(BaseComponent) {

  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  readonly navigation = inject(NAVIGATION);

  readonly sidebarService = inject(SidebarService);

  readonly user = inject(CURRENT_USER);

  private readonly t = inject(TranslateService);

  // -----------------------------------------------------------------------------------------------------
  // @ INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly isExpanded = this.sidebarService.isExpanded;

  /** The profile panel opens UPWARDS, left-aligned — below/right-aligned (the default)
   * shoots out of the viewport at the sidebar's foot. */
  readonly profileMenuPositions: ConnectedPosition[] = [
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -8 },
    { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -8 },
  ];

  // -----------------------------------------------------------------------------------------------------
  // @ METHODS
  // -----------------------------------------------------------------------------------------------------

  /** Opens the global KI assistant — same dialog the mobile header button opens. */
  openAssistant(): void {
    this.openDialog(
      {
        header: this.t.instant('Assistant.Title'),
        content: AssistantChatDialogComponent,
      },
      { width: '44rem', maxWidth: '95vw' },
    );
  }
}
